import useCommon from '@utils/hooks/common';
import {Button, Drawer, DrawerProps} from 'antd';
import React, {useEffect, useState} from 'react';
import styles from './styles';
import classNames from 'classnames';
import Icon from '@ant-design/icons';
import CardIcon from '@public/images-mobile/game-room/HistoryAndEmojiDrawer/card_button.svg';
import HistoryPanel from './HistoryPanel';
import PopupContainer from '@components/layout/PopupContainer';

interface HistoryDrawerProps extends DrawerProps {
  closeDrawer?: () => void;
  roomNumber?: number | string;
}

const HistoryDrawer = (props: HistoryDrawerProps) => {
  const {closeDrawer, roomNumber, open} = props;
  const {classes, socket, t} = useCommon({
    withStyles: styles,
    observers: ['socket', 'user'],
    withTranslation: ['history_drawer'],
  });

  const [panelType, setPanelType] = useState<'EMOJI' | 'HISTORY'>('EMOJI');

  const footer = (
    <Button
      className={classes.footerButton}
      icon={<CardIcon className={classes.buttonIcon} />}
      onClick={() => {
        if (panelType !== 'HISTORY') setPanelType('HISTORY');
      }}
    />
  );

  return (
    <PopupContainer
      visible={open}
      // height={525}
      onCancel={closeDrawer}
      title={t('title')}
    >
      <div className={classes.historyDrawerContainer}>
        <HistoryPanel closeDrawer={closeDrawer} roomNumber={roomNumber} isVisbileChange={open} />
      </div>
    </PopupContainer>
  );
};

export default HistoryDrawer;
